/**
 * Track registry + selection helpers.
 */
import type { Track, CourseDefinition } from '../types.js';
import { BUILTIN_TRACKS, EXTRA_TRACKS, HELL_TRACK, STANDARD_TRACKS } from './builtins.js';

const TRACKS_BY_ID = new Map<string, Track>(BUILTIN_TRACKS.map((t) => [t.id, t]));

export const STANDARD_ROUND: CourseDefinition = {
  id: 'standard9',
  name: 'Standard 9',
  difficulty: 'medium',
  trackIds: STANDARD_TRACKS.map((t) => t.id),
};

export function getAllTracks(): Track[] {
  return BUILTIN_TRACKS;
}

export function getTrackById(id: string): Track | undefined {
  return TRACKS_BY_ID.get(id);
}

export function getRandomTrack(): Track {
  return BUILTIN_TRACKS[Math.floor(Math.random() * BUILTIN_TRACKS.length)];
}

/** Build a round of N tracks; long rounds reserve Hellmouth as the finale. */
export function buildRound(holeCount: number): Track[] {
  const out: Track[] = [];
  if (holeCount <= STANDARD_TRACKS.length) {
    for (let i = 0; i < holeCount; i++) out.push(STANDARD_TRACKS[i]);
    return out;
  }
  // Long rounds: the standard 9, then the extras (gates, mines, magnets,
  // breakables, moveables), cycling if needed, with Hellmouth as the finale.
  const pool = [...STANDARD_TRACKS, ...EXTRA_TRACKS];
  for (let i = 0; i < holeCount - 1; i++) out.push(pool[i % pool.length]);
  out.push(HELL_TRACK);
  return out;
}

export { BUILTIN_TRACKS };
export { HELL_TRACK, STANDARD_TRACKS, EXTRA_TRACKS };
export { TrackBuilder } from './builder.js';
